var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12L12.5 10.5C12.5 7.18629 15.1863 4.5 18.5 4.5V4.5C21.8137 4.5 24.5 7.18629 24.5 10.5L24.5 12",
    stroke: "#1B1836",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21V18",
    stroke: "#1B1836",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21V18",
    stroke: "#1B1836",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16C6.5 14.1144 6.5 13.1716 7.08579 12.5858C7.67157 12 8.61438 12 10.5 12H26.5C28.3856 12 29.3284 12 29.9142 12.5858C30.5 13.1716 30.5 14.1144 30.5 16V23.5C30.5 27.2712 30.5 29.1569 29.3284 30.3284C28.1569 31.5 26.2712 31.5 22.5 31.5H14.5C10.7288 31.5 8.84315 31.5 7.67157 30.3284C6.5 29.1569 6.5 27.2712 6.5 23.5V16Z",
    stroke: "#1B1836",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.3f862eef2a35d6839eb2a5934417fe94.svg";
export { ForwardRef as ReactComponent };